<template>
  <el-dialog
    class="rc-dialog"
    title="消息群发名单导入"
    :visible.sync="showImportModal.flag"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-form
      ref="curdForm"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item>
        <butn btntype="primary" title="下载模板" @click="clickDownloadTemplate"></butn>
      </el-form-item>

      <el-form-item
        required
        label="附件："
        error="请上传附件"
        :show-message="file == null"
      >
        <upload v-model="file" ref="removeFile" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="createData" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { importUser } from "@/api/massMessage";
import Upload from "@/components/upload/excel";
import { notSystemUserTemplate } from "@/assets/excel/index.js";
import { downloadByUrl } from "../../utils/common";

export default {
  components: { butn, Upload },
  data() {
    return {
      file: null,
      EXCP: notSystemUserTemplate,
    };
  },
  props: {
    showImportModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  methods: {
    createData() {
      if (this.file != null) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        importUser(formData).then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data.successList != null) {
              this.$message.success(res.msg);
              this.closeDialog();
              this.$emit("addSucceed", res.data.successList);
            } else {
              this.$message.error("导入包含错误数据，请检查");
              this.$router.push({
                path: "/excelError",
              });
              localStorage.setItem("errorExcelData", JSON.stringify(res.data));
              this.closeDialog();
            }
          } else {
            this.$refs.removeFile.$refs.upload.uploadFiles.pop();
            this.file = null;
          }
        });
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
      // 数据重置
      this.file = null;
    },

    clickDownloadTemplate() {
      downloadByUrl(null, this.EXCP);
    },
  },
};
</script>

<style lang="scss" scoped></style>
